import { render } from "./ActionEmpty.vue?vue&type=template&id=8e7010da"
import script from "./ActionEmpty.vue?vue&type=script&lang=js"
export * from "./ActionEmpty.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__